// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.label[data-v-3ac1d968] {\r\n  font-size: 12px;\r\n  color: #999;\n}\n.slider-box[data-v-3ac1d968] {\r\n  width: 81%;\n}\n.selWidth[data-v-3ac1d968] {\r\n  width: 100% !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
